import useAuthStore from '@/stores/useAuthStore'
import { useMemo } from 'react'
import DraggableLayout, { WidgetConfig } from '../shared/DraggableLayout'

// Import shared components
import Business from '@/modules/Dashboard/components/shared/Business'
import TargetRevenue from '@/modules/Dashboard/components/shared/TargetRevenue'
import WorkDays from '@/modules/Dashboard/components/shared/WorkDays'
import MyWorkdays from '../../shared/MyWorkdays'
import Notifications from '../../shared/Notifications'
import Paper from '@/components/Paper'
import QuoteOfTheDay from '../../shared/QuoteOfTheDay'

// Import Account specific widgets
import ServiceTrendWidget from './widgets/ServiceTrendWidget'
import CancellationRateWidget from './widgets/CancellationRateWidget'
import SalesAlertsWidget from '../SalesDashboard/widgets/SalesAlertsWidget'
import WaitingConfirmWidget from './widgets/WaitingConfirmWidget'
import InvoiceWaitingWidget from './widgets/InvoiceWaitingWidget'
import Events from '../../shared/Events'
import SLACustomersWidget from '../shared/widgets/SLACustomersWidget'
import InternalInformation from '../../shared/InternalInformation'

const AccountDashboard = () => {
    const employee = useAuthStore((state) => state.employee)

    // Storage key unique per employee
    const storageKey = useMemo(
        () => `dashboard_layout_account_${employee?.employee_id || 'default'}`,
        [employee?.employee_id]
    )

    // Widget configurations with colSpan (3, 4, 6, 8, or 12)
    const widgets: WidgetConfig[] = useMemo(
        () => [
            {
                id: 'quote_of_the_day',
                component: (
                    <Paper className="h-full">
                        <QuoteOfTheDay />
                    </Paper>
                ),
                colSpan: 12,
            },
            {
                id: 'revenue',
                component: (
                    <Paper className="h-full">
                        <TargetRevenue />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'my_workdays',
                component: (
                    <Paper className="h-full">
                        <MyWorkdays />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'workday',
                component: (
                    <Paper className="h-full">
                        <WorkDays />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'service-trend',
                component: <ServiceTrendWidget />,
                colSpan: 6,
            },
            {
                id: 'cancellation-rate',
                component: <CancellationRateWidget />,
                colSpan: 6,
            },
            {
                id: 'alerts',
                component: <SalesAlertsWidget />,
                colSpan: 3,
            },
            {
                id: 'waiting-confirm',
                component: <WaitingConfirmWidget />,
                colSpan: 3,
            },
            {
                id: 'invoice-waiting',
                component: <InvoiceWaitingWidget />,
                colSpan: 3,
            },
            {
                id: 'business',
                component: (
                    <Paper className="h-full">
                        <Business />
                    </Paper>
                ),
                colSpan: 3,
            },

            {
                id: 'notification',
                component: (
                    <Paper className="h-full">
                        <Notifications />
                    </Paper>
                ),
                colSpan: 9,
            },
            {
                id: 'events',
                component: (
                    <Paper className="h-full">
                        <Events />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'sla-customers',
                component: <SLACustomersWidget />,
                colSpan: 4,
            },
            {
                id: 'internal-information',
                component: (
                    <Paper className="h-full">
                        <InternalInformation />
                    </Paper>
                ),
                colSpan: 9,
            },
        ],
        []
    )

    return (
        <DraggableLayout
            widgets={widgets}
            storageKey={storageKey}
            department="ACCOUNT"
        />
    )
}

export default AccountDashboard
